import React from 'react';
import { ActivityIndicator, Text, View } from 'react-native';
import { createStyle } from '../style';
import { JPYCTransferProps } from '../type';

type Props = {
  jpycElementProps: JPYCTransferProps;
};
export const ProgressingForm: React.FC<Props> = (props) => {
  const { jpycElementProps } = props;
  const styles = createStyle(jpycElementProps);

  return (
    <View style={styles.container}>
      <View style={styles.iconWrapper}>
        <View style={[styles.iconCircle]}>
          <ActivityIndicator size="large" color="#fff" />
        </View>
      </View>

      <View style={styles.headerBlock}>
        <Text style={styles.title}>送金中</Text>
      </View>
    </View>
  );
};
